import { EmailSignatureItemResponse, ItemResponse } from '../schema/EmailSignatureResponse';
import { ItemNames } from './itemNames';

export const extractEmailSignatureItem = (
    response: ItemResponse[]
): EmailSignatureItemResponse | undefined =>
    response.find(
        item => item.ItemClass === ItemNames.EmailSignatureSettingsItem
    ) as EmailSignatureItemResponse;
